module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/callie-gregory-f1eac7ca0fd1b84996078405eb2f5f4b.jpg";